import { useRouter } from 'vue-router';
import { RouteNames } from './RouteNames';

/* This function takes users to the page they previously accessed on the app when they come back to it after leaving it.
 * If a user is not going to the previously accessed page and is not coming away from it, they are sent to the previous page.
 * E.g. The progress stage is updated every time a page is mounted (accessed by a user). If a user is leaving the page they are on - 
 * the last page to be accessed - and then leave by clicking the next button, they are not kept on the same page
 * When a user is returning to the app, they are not coming from the page they previously accessed but they are not returning to this page, 
 * they will be taken to this page. */
export const NavigateUserPreviousPage = (toName: string, replacementPage: RouteNames) => {
  const router = useRouter();
  if (toName !== replacementPage) {
    router.replace({ name: replacementPage })
  } else {
    return true
  }
};